import { render, staticRenderFns } from "./BaseSpinner.vue?vue&type=template&id=26b13c7f&scoped=true&"
var script = {}
import style0 from "./BaseSpinner.vue?vue&type=style&index=0&id=26b13c7f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b13c7f",
  null
  
)

export default component.exports